import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import {
    Container,
    Grid,
    Typography,
    makeStyles,
    Button
} from '@material-ui/core';
import getApiConnectorRoute from "../apiRoutes";
import PackageStep from "./PackageStep";
import {useTranslation} from "react-i18next";
import LoadingOverlay from "react-loading-overlay";


const useStyles = makeStyles((theme) => ({
    root: {},
    button: {
        marginLeft: '10px'
    }
}));

const ConnectorPackagesBulk = ({ AppValues, secureFetch, ...rest }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const {t} = useTranslation('connector');
    const { state } = useLocation();
    const [processor, setProcessor] = useState(state.processor);
    const [id, setId] = useState(state.id);
    const [shipperPackages, setShipperPackages] = useState({});
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        let tmpShipperPackages = {}
        for (const [shipperId, shPackages] of Object.entries(state.packages)){
            tmpShipperPackages[shipperId] = {
                packages: shPackages,
                imported: false
            };
        }
        setShipperPackages(tmpShipperPackages);
    }, [state.packages]);

    const handlePackagesStateChange = (shipperId, packages) => {
        let tmpState = {...shipperPackages};
        tmpState[shipperId].packages = packages;
        setShipperPackages({...tmpState});
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        processPackages();
    }

    useEffect(() => {
        if (Object.keys(shipperPackages).length && !Object.keys(shipperPackages).some(shipperId => !shipperPackages[shipperId].imported)){
            //navigate to packages list
            navigate('/app/package');
        }
    }, [shipperPackages])

    const processPackages = async () => {
        setLoader(true);
        let tmpShipperPackages = {...shipperPackages};
        for (const [shipperId, packageState] of Object.entries(shipperPackages)){
            if(!packageState.imported){
                const data = packageState.packages.reduce((map, x) => {
                    map[x.order_id] = x.package;
                    return map
                }, {});
                try {
                    let result = await secureFetch(getApiConnectorRoute('import', [id, shipperId]), data, 'POST', false, true, true, true);
                    tmpShipperPackages[shipperId].imported = true;
                } catch (eResult) {
                    if (Array.isArray(eResult)) {
                        // validation errors probably
                        const tmpPackageList = [];
                        Object.entries(data).forEach(([oid, x]) => {
                            let err = eResult.find(i => i.reference_number === x.reference_number);
                            if (err) {
                                tmpPackageList.unshift({
                                    reference_number: x.reference_number,
                                    errors: err.errors,
                                    order_id: oid,
                                    package: x,
                                });
                            } else {
                                tmpPackageList.push({
                                    reference_number: x.reference_number,
                                    errors: [],
                                    order_id: oid,
                                    package: x,
                                });
                            }
                        })
                        tmpShipperPackages[shipperId].packages = tmpPackageList
                        tmpShipperPackages[shipperId].errorMessage = undefined;
                    } else if(typeof eResult === 'object' && eResult.message){
                        tmpShipperPackages[shipperId].errorMessage = eResult.message;
                        const tmpPackageList = [];
                        Object.entries(data).forEach(([oid, x]) => {
                            tmpPackageList.push({
                                reference_number: x.reference_number,
                                errors: [],
                                order_id: oid,
                                package: x,
                            });
                        })
                        tmpShipperPackages[shipperId].packages = tmpPackageList
                    } else {
                        tmpShipperPackages[shipperId].errorMessage = "Neočakávaná chyba " + JSON.stringify(eResult);
                        const tmpPackageList = [];
                        Object.entries(data).forEach(([oid, x]) => {
                            tmpPackageList.push({
                                reference_number: x.reference_number,
                                errors: [],
                                order_id: oid,
                                package: x,
                            });
                        })
                        tmpShipperPackages[shipperId].packages = tmpPackageList
                    }
                }
            }
        }
        setShipperPackages({...tmpShipperPackages});
        setLoader(false);
    }

    const handleButtonBackClick = (event) => { 
        event.preventDefault();
        navigate('/app/connector/packages', {
            state: {
                processor: processor,
                id: id
            }
        });
    }

    return (
        <Container maxWidth={false}>
                    <Typography variant="h1" gutterBottom >
                        {t('title.imported_orders')}
                    </Typography>
                    <form onSubmit={handleFormSubmit} noValidate>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                {
                                    Object.keys(shipperPackages).map((shipperId, index) =>
                                        <PackageStep
                                            shipperId={shipperId}
                                            packages={shipperPackages[shipperId]}
                                            handlePackagesStateChange={handlePackagesStateChange}
                                            key={index}
                                        />
                                    )
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end">
                                    <Button variant="contained" color="secondary" onClick={(event) => handleButtonBackClick(event) } type="button" className={classes.button}>
                                        { t('button.back') }
                                    </Button>
                                    <Button variant="contained" color="primary"  type="submit" className={classes.button}>
                                        { 'Import' }
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                    <LoadingOverlay
                        active={loader}
                        spinner
                        styles={{
                            wrapper: {position: 'static'}
                        }}
                        classNamePrefix='PackageBulkLoader_'
                        text={<Typography variant='subtitle1'>{t('messages.loading_content')}</Typography> }
                    />
                </Container>
    )
}

export default ConnectorPackagesBulk;